import {
  Combobox,
  ComboboxInput,
  ComboboxButton,
  ComboboxOption,
  ComboboxOptions,
} from "@headlessui/react";
import { useEffect, useState } from "react";
import clsx from "clsx";
import { FiChevronDown } from "react-icons/fi";

const colorPalette = [
  "bg-red-500",
  "bg-green-500",
  "bg-blue-500",
  "bg-yellow-500",
  "bg-purple-500",
  "bg-pink-500",
  "bg-indigo-500",
  "bg-rose-500",
];

const getColor = (name) => {
  if (!name || typeof name !== "string") return "bg-gray-300";
  return colorPalette[name.charCodeAt(0) % colorPalette.length];
};

export default function PatientSearchBox({
  patientList = [],
  selectedPatient = null,
  setSelectedPatient,
  disabled = false,
}) {
  const [query, setQuery] = useState("");
  const [selected, setSelected] = useState(selectedPatient);

  useEffect(() => {
    setSelected(selectedPatient);
  }, [selectedPatient]);

  const filteredPatients = Array.isArray(patientList)
    ? query === ""
      ? patientList
      : patientList.filter((p) =>
          p.patientName?.toLowerCase().includes(query.toLowerCase())
        )
    : [];

  const handleChange = (patient) => {
    setSelected(patient);
    if (setSelectedPatient) setSelectedPatient(patient);
  };

  return (
    <div className="w-full">
      <Combobox value={selected} onChange={disabled ? () => {} : handleChange}>
        <div className="relative">
          <ComboboxInput
            disabled={disabled} // ✅ Disable input
            className="w-full rounded-md border border-gray-300 bg-white py-2 pl-3 pr-10 text-sm disabled:opacity-70 disabled:cursor-not-allowed"
            placeholder="Search patients..."
            displayValue={(person) => person?.patientName || ""}
            onChange={(e) => !disabled && setQuery(e.target.value)} // ✅ Block input
          />
          <ComboboxButton
            className="absolute inset-y-0 right-0 flex items-center pr-3 top-[-8px]"
            disabled={disabled} // ✅ Disable button
          >
            <FiChevronDown className="text-gray-400" />
          </ComboboxButton>
        </div>

        {!disabled && (
          <ComboboxOptions className="mt-1 max-h-60 overflow-auto rounded-md border bg-white shadow-lg">
            {filteredPatients.map((person) => (
              <ComboboxOption
                key={person.userUniqueID}
                value={person}
                className={({ active }) =>
                  clsx(
                    "cursor-pointer select-none px-4 py-2",
                    active ? "bg-gray-100" : ""
                  )
                }
              >
                <div className="flex items-center gap-3">
                  <div
                    className={`rounded-full h-8 w-8 flex items-center justify-center text-white font-semibold text-sm ${getColor(
                      person.patientName
                    )}`}
                  >
                    {person.patientName?.[0]?.toUpperCase() || "?"}
                  </div>
                  <div>
                    <div className="font-medium text-sm">
                      {person.patientName}
                    </div>
                    <div className="text-xs text-gray-500">
                      {person.age || "-"} • {person.gender || "-"}
                    </div>
                  </div>
                </div>
              </ComboboxOption>
            ))}
            {filteredPatients.length === 0 && (
              <div className="px-4 py-2 text-sm text-gray-500">
                No patients found.
              </div>
            )}
          </ComboboxOptions>
        )}
      </Combobox>
    </div>
  );
}
